import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const LandingPageTemplateLibrary = lazy(() =>
  import("@scenes/MessageComposition/LandingPages/LandingPageTemplateLibrary").then((module) => ({
    default: module.LandingPageTemplateLibrary,
  }))
);

export const landingPageTemplatesNRO: NavigationRoutingObject = {
  section: "templates",
  Component: LandingPageTemplateLibrary,
  componentFeatureFlippers: ["landing_pages"],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("landing-page-templates-nro-heading", "Landing Page Templates"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("landing-page-templates-nro-description", "Create and manage Landing Page templates"),
  icon: "nav-system-in-app-message-templates",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("landing_pages") &&
      hasPermission("appGroupOrAnyTeamInAppGroup", {
        permission: "viewLandingPageTemplates",
      })
    );
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
};
